module.exports = __webpack_public_path__ + "static/media/principal.f62b4783.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/principal.png
// module id = 38
// module chunks = 0